import {IEnvironmentLocalStorageService} from "./environment-local-storage.service.interface";
import {EnvLocalStorageKeys} from "./environment-local-storage-keys";
import {StorageServiceBase} from "../storage-service-base";
import {IServiceFactory} from "../../service-factory.interface";
import {UndefinedString} from "../../../types/nullable-types";

/**
 * Appends the environment type to the keys
 */

export class EnvironmentLocalStorageService extends StorageServiceBase<EnvLocalStorageKeys> implements IEnvironmentLocalStorageService {
    constructor(services: IServiceFactory) {
        super(localStorage, services);
    }

    protected get _storageName(): string {
        return "environmentLocalStorage";
    }

    protected _composeKey(key: EnvLocalStorageKeys, discriminator: UndefinedString): string {
        if(discriminator) {
            return `${key}.${this.services.configuration.currentEnvironmentType}.${discriminator}`;
        } else {
            return `${key}.${this.services.configuration.currentEnvironmentType}`;
        }
    }

    protected _clearLargeStorageConsumersData() {
        this.services.largeStorageConsumersManager.clearLocalStorageConsumers();
    }
}
